/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EVMChain } from './EVMChain';
import {
    EVMChainFromJSON,
    EVMChainFromJSONTyped,
    EVMChainToJSON,
    EVMChainToJSONTyped,
} from './EVMChain';

/**
 * Represents a guild to keep track of DevourPlay games.
 * @export
 * @interface Guild
 */
export interface Guild {
    /**
     * 
     * @type {string}
     * @memberof Guild
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Guild
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof Guild
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof Guild
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Guild
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Guild
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Guild
     */
    games: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Guild
     */
    nftGrouping: string;
    /**
     * 
     * @type {number}
     * @memberof Guild
     */
    totalPoints: number;
    /**
     * 
     * @type {number}
     * @memberof Guild
     */
    monthlyPoints: number;
    /**
     * 
     * @type {string}
     * @memberof Guild
     */
    autoMintContract?: string;
    /**
     * 
     * @type {EVMChain}
     * @memberof Guild
     */
    autoMintChain?: EVMChain;
    /**
     * 
     * @type {string}
     * @memberof Guild
     */
    hero?: string;
    /**
     * 
     * @type {string}
     * @memberof Guild
     */
    icon?: string;
    /**
     * 
     * @type {number}
     * @memberof Guild
     */
    rank?: number;
    /**
     * 
     * @type {number}
     * @memberof Guild
     */
    monthlyRank?: number;
    /**
     * 
     * @type {number}
     * @memberof Guild
     */
    memberCount?: number;
    /**
     * 
     * @type {string}
     * @memberof Guild
     */
    bannerImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof Guild
     */
    bannerImageLarge?: string;
}



/**
 * Check if a given object implements the Guild interface.
 */
export function instanceOfGuild(value: object): value is Guild {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('games' in value) || value['games'] === undefined) return false;
    if (!('nftGrouping' in value) || value['nftGrouping'] === undefined) return false;
    if (!('totalPoints' in value) || value['totalPoints'] === undefined) return false;
    if (!('monthlyPoints' in value) || value['monthlyPoints'] === undefined) return false;
    return true;
}

export function GuildFromJSON(json: any): Guild {
    return GuildFromJSONTyped(json, false);
}

export function GuildFromJSONTyped(json: any, ignoreDiscriminator: boolean): Guild {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'],
        'games': json['games'],
        'nftGrouping': json['nftGrouping'],
        'totalPoints': json['totalPoints'],
        'monthlyPoints': json['monthlyPoints'],
        'autoMintContract': json['autoMintContract'] == null ? undefined : json['autoMintContract'],
        'autoMintChain': json['autoMintChain'] == null ? undefined : EVMChainFromJSON(json['autoMintChain']),
        'hero': json['hero'] == null ? undefined : json['hero'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'rank': json['rank'] == null ? undefined : json['rank'],
        'monthlyRank': json['monthlyRank'] == null ? undefined : json['monthlyRank'],
        'memberCount': json['memberCount'] == null ? undefined : json['memberCount'],
        'bannerImageSmall': json['bannerImageSmall'] == null ? undefined : json['bannerImageSmall'],
        'bannerImageLarge': json['bannerImageLarge'] == null ? undefined : json['bannerImageLarge'],
    };
}

export function GuildToJSON(json: any): Guild {
    return GuildToJSONTyped(json, false);
}

export function GuildToJSONTyped(value?: Guild | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'description': value['description'],
        'isActive': value['isActive'],
        'games': value['games'],
        'nftGrouping': value['nftGrouping'],
        'totalPoints': value['totalPoints'],
        'monthlyPoints': value['monthlyPoints'],
        'autoMintContract': value['autoMintContract'],
        'autoMintChain': EVMChainToJSON(value['autoMintChain']),
        'hero': value['hero'],
        'icon': value['icon'],
        'rank': value['rank'],
        'monthlyRank': value['monthlyRank'],
        'memberCount': value['memberCount'],
        'bannerImageSmall': value['bannerImageSmall'],
        'bannerImageLarge': value['bannerImageLarge'],
    };
}

